export const ImagesFiles = {
  //Color palette images
  stroke_pen_black:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/stroke_pen_black.png',
  stroke_pen_blue:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/stroke_pen_blue.png',
  stroke_pen_yellow:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/stroke_pen_yellow.png',
  stroke_pen_red:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/stroke_pen_red.png',
  shape_select:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/shape_select.png',
  shape_unselect:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/shape_unselect.png',
  select_arrow_select:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/select_arrow_select.png',
  select_arrow_unselect:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/select_arrow_unselect.png',
  replay_icon:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/replay_icon.png',
  star_white:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/star_white.png',
  star_gold:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/star_gold.png',
  //Smart label modes images
  label_type:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/label_type.png',
  label_shuffle:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/label_shuffle.png',
  label_select:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/label_select.png',
  label_match:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/label_match.png',
  label_answer:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/label_answer.png',
  label_type_selected:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/label_type_selected.png',
  label_shuffle_selected:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/label_shuffle_selected.png',
  label_select_selected:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/label_select_selected.png',
  label_match_selected:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/label_match_selected.png',
  label_answer_selected:
    'https://learnpodseditornodeserver.knomadixapp.com/backpack/label_answer_selected.png'
}
